import { useContext } from "react";
import { useNavigate } from "react-router-dom";

import { ProjectPermissionConstants } from "../../../../../../../constants";
import { useAuth } from "../../../../../../../useAuth";
import { useProjectAccessInvite, UseProjectAccessInviteReturnData } from "../../../../../../../utils";
import { getProjectAccessRoute } from "../../../../../../../utils/routes";
import { ProjectContext } from "../../../ProjectContext";

interface useInviteFormReturnData extends UseProjectAccessInviteReturnData {
  onCancel: () => void;
}

export const useInviteForm = (): useInviteFormReturnData => {
  const navigate = useNavigate();
  const { currentUserType } = useAuth();

  const { projectDetails, hasProjectPermission } = useContext(ProjectContext);
  // The uuid, not the object: projectDetails changes identity on every refetch.
  const projectUuid = projectDetails?.uuid;

  const navigateToProjectAccess = (): void => {
    if (projectUuid) {
      navigate(getProjectAccessRoute(projectUuid, currentUserType));
    }
  };

  const invite = useProjectAccessInvite({
    projectUuid,
    canManageAccess: hasProjectPermission(ProjectPermissionConstants.MANAGE_PROJECT_ORGANISATION_INVITATION),
    currentResponsibleOwnerName: projectDetails?.responsibleOwner?.displayName ?? undefined,
    onSent: navigateToProjectAccess,
  });

  return {
    ...invite,
    onCancel: navigateToProjectAccess,
  };
};
